/* Vault: Warenkorb-Extras – Shipping-Protection-Schalter und Upsell-Button */
if (!customElements.get('vault-cart-action')) {
  class VaultCartAction extends HTMLElement {
    connectedCallback() {
      this.querySelector('[data-toggle]')?.addEventListener('change', (e) => this.toggle(e.target.checked));
      this.querySelector('[data-add]')?.addEventListener('click', () => this.add());
    }

    sections() {
      const drawer = document.querySelector('cart-drawer');
      return drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
    }

    busy(on) {
      this.classList.toggle('is-loading', on);
      this.querySelectorAll('input, button').forEach((el) => (el.disabled = on));
    }

    async post(url, body) {
      this.busy(true);
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ ...body, sections: this.sections(), sections_url: window.location.pathname }),
        });
        const data = await res.json();
        if (data.status) throw new Error(data.description || data.message);
        const drawer = document.querySelector('cart-drawer');
        if (drawer && data.sections) drawer.renderContents(data);
        else window.location.reload();
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vault-cart', cartData: data });
        }
      } catch (e) {
        console.error(e);
        this.busy(false);
        const t = this.querySelector('[data-toggle]');
        if (t) t.checked = !t.checked;
      }
    }

    toggle(on) {
      if (on) return this.add();
      const key = this.dataset.lineKey;
      if (key) this.post(`${window.routes.cart_change_url}.js`, { id: key, quantity: 0 });
    }

    add() {
      this.post(`${window.routes.cart_add_url}.js`, { items: [{ id: Number(this.dataset.variantId), quantity: 1 }] });
    }
  }
  customElements.define('vault-cart-action', VaultCartAction);
}
